export const switchImgAppend = (img: any, uploadData: FormData) => {
  if (img === 'default') return uploadData.append('img', '');
  if (img[0]) return uploadData.append("img", img[0], img[0].name);
}